import { createFileRoute } from '@tanstack/react-router';
import { ProdutoresView } from '@/modules/agronomia/components/ProdutoresView';
import { SelecaoAgronomiaView } from '@/modules/agronomia/components/SelecaoAgronomiaView';

// Raiz do módulo Agronomia.
// Desktop (≥lg): tela 00 · seleção em pipes (Produtores / Catálogo de insumos).
// Mobile/APK: cai direto em Produtores — fluxo de campo intocado.
export const Route = createFileRoute('/_authed/agronomia')({
  component: AgronomiaRaiz,
});

function AgronomiaRaiz() {
  return (
    <>
      <div className="hidden h-full lg:block">
        <SelecaoAgronomiaView />
      </div>
      <div className="h-full lg:hidden">
        <ProdutoresView />
      </div>
    </>
  );
}
